export default __webpack_public_path__ + "static/media/soulbond-icon.87dfd58f.svg";